import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Modal from '../../../../../shared/components/modal/modal';
import OiFormInput from '../../../../../shared/components/OiForm/OiFormInput';
import { getUserProfile, setProcessLoading, updateUserProfile } from '../../../../../store/action';
import ForgotPassword from '../../../../../shared/components/ForgotPassword/ForgotPassword';
import OiButton from '../../../../../shared/components/Common/OiButton/OiButton';
import { isEmailValid, isEmpty, isValidLength } from '../../../../../shared/helpers/validate';
import { detectChanges } from '../../../../../shared/helpers/utils';

const UserProfile = props => {
    const { error, processLoading } = useSelector(({ Util }) => Util);
    const { userProfile } = useSelector(({ Profile }) => Profile);
    const dispatch = useDispatch();
    // const state = useSelector(state => state.state)
    const [state, setState] = useState({
        userProfile: {},
        changePassword: false,
        validate: {
            firstName: '',
            lastName: '',
            phone: '',
            email: ''
        },
        errors: {}
    });

    useEffect(() => {
        dispatch(getUserProfile());
    }, []);

    useEffect(() => {
        const { firstName, lastName, email, phone } = userProfile;
        if (detectChanges(state.validate, userProfile)) {
            const cloned = { ...state.validate };
            cloned['firstName'] = firstName || '';
            cloned['lastName'] = lastName || '';
            cloned['email'] = email || '';
            cloned['phone'] = phone || '';

            // Surface validation errors for pre-filled/missing fields immediately,
            // so a permanently-disabled Submit button isn't silent about why.
            const errors = {};
            if (isEmpty(cloned.firstName) || isValidLength(cloned.firstName, 3))
                errors.firstName = isValidLength(cloned.firstName, 3);
            if (isEmpty(cloned.lastName) || isValidLength(cloned.lastName, 3))
                errors.lastName = isValidLength(cloned.lastName, 3);
            if (isEmpty(cloned.phone) || isValidLength(cloned.phone, 11))
                errors.phone = isValidLength(cloned.phone, 11);
            if (isEmpty(cloned.email) || isEmailValid(cloned.email)) errors.email = isEmailValid(cloned.email);

            setState({ ...state, validate: cloned, errors });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userProfile]);

    const validate = () => {
        const { firstName, lastName, email, phone } = state.validate;
        const errors = {};

        // Current Password Test Validation
        if (isEmpty(phone) || isValidLength(phone, 11)) errors.phone = isValidLength(phone, 11);
        // New Password Test Validation
        if (isEmpty(email) || isEmailValid(email)) errors.email = isEmailValid(email);
        // Confirm Password Test Validation
        if (isEmpty(firstName) || isValidLength(firstName, 3)) errors.firstName = isValidLength(firstName, 3);
        if (isEmpty(lastName) || isValidLength(lastName, 3)) errors.lastName = isValidLength(lastName, 3);
        return Object.keys(errors).length === 0 ? null : errors;
    };

    const validateProperty = ({ target }) => {
        const { name, value } = target;
        if (name === 'firstName') return isEmpty(value) || isValidLength(value, 3);
        if (name === 'lastName') return isEmpty(value) || isValidLength(value, 3);
        if (name === 'phone') return isEmpty(value) || isValidLength(value, 11);
        if (name === 'email') return isEmpty(value) || isEmailValid(value);
    };

    const handleChange = event => {
        const { name, value } = event.target;
        const errors = { ...state.errors };
        const errorMessage = validateProperty(event);
        if (errorMessage) {
            errors[name] = errorMessage;
        } else {
            delete errors[name];
        }
        // -- Validation -->
        const validate = { ...state.validate };
        validate[name] = value;
        setState({ ...state, validate, errors });
    };

    const handleSubmit = event => {
        event.preventDefault();
        const {
            validate: { email, lastName, firstName, phone }
        } = state;
        const value = { email, firstName, lastName, phone };

        dispatch(updateUserProfile(value));
        dispatch(setProcessLoading(true));
    };
    const handlePasswordVisibility = () => {
        setState({ ...state, changePassword: !state.changePassword });
    };
    const {
        errors,
        changePassword,
        validate: { firstName, lastName, email, phone }
    } = state;
    return (
        <>
            <div className="content-background">
                <div className="content-background__wrapper">
                    <h2 className="settings__header u-half-gradient-bg">User Profile</h2>

                    <div className="oi-settings__data">
                        <form className="oi-form" onSubmit={handleSubmit}>
                            <div className="oi-form__section  u-margin-top-3_5">
                                {/* <div className="oi-settings-section__title  u-half-gradient-bg">User Details</div> */}

                                <div className="oi-form__group">
                                    <div className="oi-form__model-direction">
                                        <div className="oi-form__associate-1-of-2">
                                            <OiFormInput
                                                labelClass="oi-form__label-primary"
                                                inputClass="oi-form__input-primary oi-form__input--height4"
                                                name="firstName"
                                                type="text"
                                                label="First Name"
                                                hook="profile-first-name"
                                                onChange={handleChange}
                                                inputValue={firstName}
                                                error={errors['firstName']}
                                            />
                                        </div>
                                        <div className="oi-form__associate-1-of-2  u-margin-top-switch">
                                            <OiFormInput
                                                labelClass="oi-form__label-primary"
                                                inputClass="oi-form__input-primary oi-form__input--height4"
                                                name="lastName"
                                                type="text"
                                                label="Last Name"
                                                hook="profile-last-name"
                                                onChange={handleChange}
                                                placeholder="Enter your last name"
                                                inputValue={lastName}
                                                error={errors['lastName']}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="oi-form__group">
                                    <div className="oi-form__model-direction">
                                        <div className="oi-form__associate-1-of-2">
                                            <OiFormInput
                                                labelClass="oi-form__label-primary"
                                                inputClass="oi-form__input-primary oi-form__input--height4"
                                                name="email"
                                                type="text"
                                                label="Email"
                                                hook="profile-email"
                                                onChange={handleChange}
                                                placeholder="Enter your email"
                                                inputValue={email}
                                                disable={true}
                                                error={errors['email']}
                                            />
                                        </div>
                                        <div className="oi-form__associate-1-of-2  u-margin-top-switch">
                                            <OiFormInput
                                                labelClass="oi-form__label-primary"
                                                inputClass="oi-form__input-primary oi-form__input--height4"
                                                name="phone"
                                                type="text"
                                                label="Phone Number"
                                                hook="profile-phone-number"
                                                onChange={handleChange}
                                                placeholder="Enter your phone number"
                                                inputValue={phone}
                                                error={errors['phone']}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="oi-form__group">
                                    <button
                                        type="button"
                                        className="oi-form__password-change-label"
                                        onClick={handlePasswordVisibility}>
                                        Change Password
                                    </button>
                                </div>
                            </div>

                            <div className="u-margin-top-3_5">
                                <OiButton
                                    disabled={validate()}
                                    buttonLoader={processLoading}
                                    styles="oi-btn oi-btn--primary oi-btn--stretch oi-btn--radius5 oi-btn--height45 | u-font14sb"
                                    type="submit">
                                    Submit
                                </OiButton>
                            </div>
                        </form>

                        <Modal modalVisibility={changePassword} onModalChange={handlePasswordVisibility}>
                            <ForgotPassword
                                processing={processLoading}
                                changePassword={changePassword}
                                handlePasswordVisibility={handlePasswordVisibility}
                                error={error}
                            />
                        </Modal>
                    </div>
                </div>
            </div>
        </>
    );
};

export default UserProfile;
// const mapStateToProps = state => {
//     const { userProfile } = state.Profile;
//     const { success, error } = state.Util;

//     return {
//         userProfile,
//         success,
//         error
//     };
// };
// export default connect(mapStateToProps, {
//     getUserProfile,
//     updateUserProfile,
//     setProcessLoading,
//     updatePassword,
//     setSuccess,
//     setError
// })(UserProfile);
